/**
 * Func that removes an item from the array and returns it as a new array.
 * Note that Array.splice() does not return a new array, but this method does.
 */
export function removeItemFromArray(array, item) {
  const splice = Array.from(array);
  splice.splice(array.indexOf(item), 1);
  return splice;
}
